// extracted by mini-css-extract-plugin
module.exports =  {"horizontal-group":"_93444fe79c--horizontal-group--o1T8f","vertical-group":"_93444fe79c--vertical-group--kz0pR"};